<template>
  <div class="filters-container mb-4">
    <div class="d-flex align-items-center mb-3">
      <input 
        type="checkbox" 
        :checked="showFilters"
        @change="$emit('toggle-filters')"
        class="form-check-input me-2"
        id="show-filters"
      >
      <label for="show-filters" class="form-check-label">
        <small>Mostrar filtros</small>
      </label>
    </div>

    <div v-if="showFilters" class="filters-grid">
      <div class="row">
        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Nombre"
            :value="filters.firstname"
            @input="updateFilter('firstname', $event)"
            placeholder="Buscar por nombre"
          />
        </div>

        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Apellido"
            :value="filters.lastname"
            @input="updateFilter('lastname', $event)"
            placeholder="Buscar por apellido"
          />
        </div>

        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Email"
            type="email"
            :value="filters.email"
            @input="updateFilter('email', $event)"
            placeholder="Buscar por email"
          />
        </div>

        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Cargo"
            :value="filters.position"
            @input="updateFilter('position', $event)"
            placeholder="Buscar por cargo"
          />
        </div>

        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Área"
            :value="filters.area"
            @input="updateFilter('area', $event)"
            placeholder="Buscar por área"
          />
        </div>

        <div class="col-md-4 col-sm-6 mb-3">
          <FilterField
            label="Fecha de creación"
            type="date"
            :value="filters.fecha"
            @input="updateFilter('fecha', $event)"
            placeholder="Buscar por fecha"
          />
        </div>

        <div class="col-12">
          <div class="d-flex gap-2">
            <button 
              class="btn bg-utel text-white rounded-8" 
              @click="$emit('filter')"
            >
              <i class="fas fa-search me-1"></i>
              Filtrar
            </button>
            
            <button 
              class="btn bg-secondary text-white rounded-8" 
              @click="$emit('clear')"
            >
              <i class="fas fa-times me-1"></i>
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterField from './FilterField.vue'

export default {
  name: 'UserFilters',
  
  components: {
    FilterField
  },

  props: {
    filters: { type: Object, required: true },
    showFilters: { type: Boolean, default: false }
  },

  emits: ['update-filters', 'toggle-filters', 'filter', 'clear'],

  methods: {
    updateFilter(field, value) {
      this.$emit('update-filters', {
        ...this.filters,
        [field]: value
      })
    }
  }
}
</script>

<style scoped>
.filters-container {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
}

.filters-grid {
  margin-top: 1rem;
}
</style>